<template>
  <div v-if="isLoading" class="loading-overlay">

      <div class="loading-message">
      <v-img
        :src="require('../assets/loading.png')" 
        alt="Logo"
        max-width="350"
      ></v-img>

      <p >{{ message }}</p>
      </div>
  </div>
</template>

<script>


export default {
  name: 'ComponenteLoading',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
.loading-overlay-old {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7); /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Asegura que el spinner esté sobre todo */
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center; /* Centrar horizontalmente */
  align-items: center;    /* Centrar verticalmente */
  z-index: 9999;
}

.loading-content { /* Nuevo contenedor para el contenido */
  display: flex;
  flex-direction: column; /* Alinea los elementos verticalmente */
  align-items: center;    /* Centrar horizontalmente los elementos */
}


.loading-message {
  color: white;
  font-size: 24px;
  margin-top: 10px; /* Espacio entre imagen y texto */
  text-align: center; /* Centrar el texto */
}


</style>
